import { useRef } from 'react';

/**
 * Basically `useRef` but accepts an initial value of another ref.
 *
 * For cases where we want an external forwardRef and an internal useRef.
 */
const useMergedRef = initialRef => {
  const localRef = useRef();
  return initialRef || localRef;
};
export default useMergedRef;